export default __webpack_public_path__ + "static/media/checkAnim.f92ce36f.gif";